import classNames from "classnames"
import React from "react"

type PayflexLogoProps = {
  size?: "small" | "large"
}

export const PayflexLogo = ({ size = "small" }: PayflexLogoProps) => (
  <div
    className={classNames(
      "flex items-center justify-center bg-payflex-purple",
      {
        "h-[30px] w-[90px] rounded-8 px-[8px] py-[7px] sm:h-[35px] sm:w-[105px] sm:px-[9px] sm:py-[8px]":
          size === "small",
      },
      {
        "h-[50px] w-[148px] rounded-[71px] px-[15px] py-[12px] sm:h-[71px] sm:w-[207px] sm:rounded-[100px] sm:px-[22px] sm:py-[18px]":
          size === "large",
      }
    )}
  >
    <img
      className="h-full w-auto"
      src="/icons/payflex-logo.svg"
      alt="Payflex Logo"
    />
  </div>
)
